/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";
import { deepClone } from "@/helpers/utils.js";
import Product from "@/classes/Product";

/* Exports */
// API services that can be invoked on the modules
export const PRODUCTS_SERVICE = {postProduct, getProducts, putProduct, getProductDetails, deleteProductById};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "MainProducts";

/* Services */
//Service to create products
function postProduct(input)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), "Content-Type":"application/json" },
        body: JSON.stringify(input)
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to get paginated products
function getProducts(queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, queryParams, requestOptions);
}


//Service to update products
function putProduct(input) {
    console.log('Input before sending to API:', input);

    // Ensure datasheets, mainProductInfos, or other properties are properly formatted
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE]);

    // Check for undefined or null properties and set defaults
    var copy = deepClone(new Product, input);

    // For example, make sure datasheets is an object
    copy.datasheets = copy.datasheets || {};
    Object.keys(copy.datasheets).forEach(function (key, index) {
        if (typeof copy.datasheets[key] === 'string' || copy.datasheets[key] instanceof String) {
            copy.datasheets[key] = { path: copy.datasheets[key] };
        }
    });

    // Make sure other fields like mainProductInfos are initialized correctly
    copy.mainProductInfos = copy.mainProductInfos || [];
    copy.mainProductInfos = copy.mainProductInfos.map(info => ({
        ...info,
        keys: info.keys || { pt: '', en: '' },
        values: info.values || { pt: '', en: '' }
    }));

    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(copy)
    };

    return API_HELPER.loggedApiCall(url, null, requestOptions);
}



//Service to get products details
function getProductDetails(uniqueIdentifier)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, uniqueIdentifier]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}


//Service to delete products
function deleteProductById(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, id]);

    const requestOptions = {
        method: 'DELETE',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}
